import request from '../request'

// 获取用户信息接口
export const userGetInfo = () => {
  return request({
    url: '/my/profile',
    method: 'GET',
    requiresAuth: true
  })
}

// 更新用户信息接口
export const userUpdateInfo = (params) => {
  return request({
    url: '/my/profile',
    method: 'PUT',
    data: params,
    requiresAuth: true
  })
}

// 上传用户头像接口
export const uploadUserAvatar = (file) => {
  const formData = new FormData()
  formData.append('avatar', file)
  return request({
    url: '/my/avatar',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    requiresAuth: true
  })
}

// 查询接收客资开关状态
export const getReceiveCustomers = () => {
  return request({
    baseType: 'api',
    url: '/my/online',
    method: 'GET',
    requiresAuth: true
  })
}

// 设置接收客资开关状态
export const setReceiveCustomers = (status) => {
  return request({
    baseType: 'api',
    url: '/my/online',
    method: 'PUT',
    params: { online: status },
    requiresAuth: true
  })
}
